import { Link } from "react-router-dom";

function Computerlab() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active"> AI & Robotics lab</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> AI Robotics lab </h1>
            <p>
              AI & Robotics introduce students to modern technologies by
              exploring intelligent systems, coding, automation, and the
              operation of programmable robots, helping them develop
              problem-solving skills, creativity, and technological awareness
              while preparing them for future innovations in science and
              engineering.
            </p>
          </div>
        </div>
        <br />
      </div>
    </>
  );
}
export default Computerlab;
